import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";

const statusApi = createApi({
  reducerPath: "base/status",
  baseQuery: axiosBaseQuery,
  tagTypes: ["statusList"],
  endpoints: (builder) => ({
    // Fetch all statuses, optionally filtered
    statusFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
      providesTags: ["statusList"],
      query: (query = "") => ({
        url: "/base/status" + query,
        method: "GET",
      }),
      transformResponse: (response: any) => ({
        data: response.data,
        pagination: response.pagination,
      }),
    }),

    statusFindOne: builder.query<{ data: any }, number>({
      query: (id) => ({
        url: `/base/status/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useStatusFindAllQuery,
  useStatusFindOneQuery,
} = statusApi;

export { statusApi };
